<template>
  <div class="container">
    <div class="main">
      <div class="turntable">
        <!-- <div class="mask" v-if="isStart"></div> -->
        <div class="turnItem" :class="{ active: prizeIndex == 0 }">
          <div class="turnContent">
            <img :src="'' + prizeData[0].giftPic" />
            <p>{{ prizeData[0].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 1 }">
          <div class="turnContent">
            <img :src="'' + prizeData[1].giftPic" />
            <p>{{ prizeData[1].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 2 }">
          <div class="turnContent">
            <img :src="'' + prizeData[2].giftPic" />
            <p>{{ prizeData[2].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 7 }">
          <div class="turnContent">
            <img :src="'' + prizeData[7].giftPic" />
            <p>{{ prizeData[7].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem turnBtn">
          <el-button
            type="text"
            :disabled="isDisBtn"
            @click="startLuckyDraw()"
            class="turnContent"
          ></el-button>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 3 }">
          <div class="turnContent">
            <img :src="'' + prizeData[3].giftPic" />
            <p>{{ prizeData[3].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 6 }">
          <div class="turnContent">
            <img :src="'' + prizeData[6].giftPic" />
            <p>{{ prizeData[6].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 5 }">
          <div class="turnContent">
            <img :src="'' + prizeData[5].giftPic" />
            <p>{{ prizeData[5].actPriName }}</p>
          </div>
        </div>
        <div class="turnItem" :class="{ active: prizeIndex == 4 }">
          <div class="turnContent">
            <img :src="'' + prizeData[4].giftPic" />
            <p>{{ prizeData[4].actPriName }}</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
 
<script>
import {
  getLotUserCount,
  getLotluckDraw,
  getLotprizeList,
} from "../api/InteractiveLottery";
import { Dialog, Toast } from "vant";
import { filePerviewPath } from "@/api/globalApi.js";
import addYears from "date-fns/esm/addYears";
import set from "date-fns/set/index";
import { mapState, mapMutations } from "vuex";
import {
 
  opneLoginPane,
  setUser,
} from "@/utils/app";
export default {
  name: "LuckyDraw",
  data() {
    return {
      isStart: false, //是否开始了抽奖
      isDisBtn: false, //是否禁用中心抽奖按钮防止连续点击
      prizeTimer: null,
      speed: 50, //转盘速度
      prizeIndex: null, //用来定位白块
      circleNumber: 5, //转盘圈数
      prizeData: [
        //奖品数据
      ],
      luckyGift: {}, //中奖信息
      num: "", //抽奖次数
    };
  },
  mounted() {
    this.getLuckyDrawInfo();
  },
  computed: {
    ...mapState(["IOS", "Android"]),
  },
  methods: {
    getLuckyDrawInfo() {
      getLotprizeList({ actLotId: this.$route.query.actLotId }).then(
        ({ data }) => {
          if (data.code == 200) {
            this.prizeData = data.data;
            this.prizeData.map((ele) => {
              if (!ele.emptyPrize) {
                ele.giftPic = filePerviewPath({
                  fileObjId: ele.actPriFileObjId,
                  downType: "cover",
                });
                ele.actPriName = ele.actPriName.substring(0, 4);
              } else {
                ele.giftPic = require("../assets/interacactiveLottery/empty.png");
              }
            });
          }
        }
      );
    },
    async startLuckyDraw() {
      this.isDisBtn = true;
      //点击抽奖后立即禁用按钮，防连续点击
      if (localStorage.getItem("token") == null && !this.IOS && !this.Android) {
        Dialog.confirm({
          message: "请登录后参与此活动。",
          title: "",
        })
          .then(() => {
            // console.log(this.$route);
            localStorage.setItem("path", this.$route.fullPath);
            this.$router.push({
              path: "/login",
              query: { webTenId: this.$route.query.webTenId },
            });
          })
          .catch(() => {
            return false;
          });
      } else {
        if (localStorage.getItem("token") == null) {
          this.isDisBtn = false;
          opneLoginPane();
          let timer = setInterval(async () => {
            if (localStorage.getItem("token") != null) {
              clearInterval(timer);
              this.num = await getLotUserCount({
                actLotId: this.$route.query.actLotId,
              });
              this.$bus.$emit("num", this.num.data.data);
            }
          }, 1000);
          return false;
        }
        this.num = await getLotUserCount({
          actLotId: this.$route.query.actLotId,
        });
        if (this.num.data.data > 0) {
          getLotluckDraw({ actLotId: this.$route.query.actLotId }).then(
            async ({ data }) => {
              if (data.code == 200) {
                this.prizeIndex = 0; //从第一个奖品开始转
                this.horseRaceLamp(data.data); //中奖id
                this.num = await getLotUserCount({
                  actLotId: this.$route.query.actLotId,
                });
                this.$bus.$emit("num", this.num.data.data);
              } else {
                this.isDisBtn = false;
              }
            }
          );
        } else {
          Toast.fail("您的抽奖次数为0");
        }
      }
    },
    horseRaceLamp(findIndex) {
      this.isStart = true; //打开灰色遮罩
      this.prizeTimer = setInterval(() => {
        //最后一圈且index与中奖index相同时关闭定时器
        if (this.circleNumber == 0 && this.prizeIndex == findIndex) {
          clearInterval(this.prizeTimer);
          this.isDisBtn = false;
          this.circleNumber = 5;
          this.speed = 50;
          return;
          //还剩一圈时减速
        } else if (this.circleNumber == 1) {
          clearInterval(this.prizeTimer);
          this.speed += 35;
          this.horseRaceLamp(findIndex);
        }
        //定位的index为7时，减一圈，重置定位的index
        if (this.prizeIndex == 7) {
          this.prizeIndex = 0;
          this.circleNumber--;
        } else {
          this.prizeIndex++;
        }
      }, this.speed);
    },
    // setUserInfo: function (data) {
    //   console.log("app登录信息", JSON.parse(data).data.token);
    //   setUser(data);
    //   window.sessionStorage.setItem("userinfo", JSON.stringify(data));
    //   window.localStorage.setItem("token", JSON.parse(data).data.token);
    //   console.log("抽奖此说", this.num.data.data);
    // },
  },
};
</script>
 
<style  scoped>
.main {
  width: 95%;
  background: #ffb156;
  margin: 0 auto;
  padding: 0.32rem;
  box-sizing: border-box;
  background: #ffb258;
  border: 1px solid #ffb156;
  box-shadow: inset 0px 0px 15px 8px #ffcd94;
  border-radius: 0.53rem;
}

.turntable {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  margin: 0 auto;
  background: #fed477;
  padding: 0.32rem;
  box-sizing: border-box;
  border-radius: 0.53rem;
  position: relative;
}

.turnContent {
  text-align: center;
  padding: 0.28rem;
}
.turnContent img {
  width: 1.2rem;
  height: 0.8rem;
}
.turnContent p {
  font-size: 0.28rem;
  margin-top: -0.2rem;
}
.turnItem {
  position: relative;
  width: 31%;
  height: 1.78rem;
  /* padding-top: 31%; */
  /* margin-bottom: 4rem; */
  margin-right: 0.2rem;
  /* border-radius: 2rem; */
  background-color: #ffffff;
  margin-bottom: 0.2rem;
  /* box-shadow: 0 2.133333rem 0 #ffe9a4; */
  border-radius: 0.26rem;
  box-shadow: inset 0px -4px 4px #dad4c7;
}
.turntable .turnItem:nth-child(3n) {
  margin-right: 0rem;
}
.turntable .turnItem:nth-child(n + 7) {
  margin-bottom: 0rem;
}
.turnBtn {
  background: url("../assets/interacactiveLottery/start.png") no-repeat;
  background-size: 88%;
  border-radius: 0;
  box-shadow: none;
  background-position-x: center;
  background-position-y: center;
}

/deep/ .el-button {
  background: url("../assets/interacactiveLottery/start.png") no-repeat;
  width: 100%;
  height: 100%;
  background-size: 93%;
  background-position-x: center;
  background-position-y: center;
}
.mask {
  position: absolute;
  width: 20rem;
  height: 20rem;
  /* background: rgba(12, 12, 12, 0.293); */
}
.active {
  background: #ffbaa8;
  border: 1px solid #ff6464;
  box-sizing: border-box;
  box-shadow: inset 0px -4px 4px #ff8b83;
}
</style>